import(/* webpackMode: "eager" */ "/home/runner/work/interclinic/interclinic/packages/web/app/layout.tsx");
